import { handleService } from './common'

export default {
  // 分页获得门牌设备列表
  GetSpaceEquListByPgae (data) {
    let url = '/api/Device/GetSpaceEquListByPgae'
    return handleService(url, data)
  }
}
